// extracted by mini-css-extract-plugin
module.exports = {"pill":"styles_pill__JEcD9","bg":"styles_bg__eHK4a","icon":"styles_icon__YP6RO"};